export default "__VITE_ASSET__40d78a90__"